/**
 * Scroll-reveal via IntersectionObserver.
 *
 * Elements with the `.reveal` class start hidden (CSS adds the
 * pre-reveal styles), then transition to `.is-visible` when they enter
 * the viewport. Once revealed they stay revealed (we unobserve).
 *
 * Honors `prefers-reduced-motion`: if the user has requested reduced
 * motion, everything is revealed immediately.
 */

const REVEAL_ATTR = 'data-stagger-ms';

export function setupScrollReveal() {
  const targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const stagger = Number(el.getAttribute(REVEAL_ATTR) || 0);
        window.setTimeout(() => el.classList.add('is-visible'), stagger);
        observer.unobserve(el);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
  );

  targets.forEach((el) => observer.observe(el));
}
